import { handlers } from '../../helpers/helpers';

const { useState, useEffect } = require('react');

const useSaveSurveyData = () => {
  const [surveyDataToSave, setSurveyDataToSave] = useState();

  const finishSurvey = () => {
    const localStorageData = JSON.parse(localStorage.getItem('surveyData'));

    localStorageData.is_finish = true;

    const questionFromSummary = JSON.parse(localStorage.getItem('questionToEdit'));

    if (questionFromSummary) {
      localStorageData.surveys.map((survey) => {
        return {
          ...survey,
          current: false
        }
      });

      localStorage.removeItem('questionToEdit');
    }

    handlers.handleSurveyData(localStorageData);
  };

  useEffect(() => {
    if (surveyDataToSave) {
      const localStorageData = JSON.parse(localStorage.getItem('surveyData'));
      const actualCurrentSurvey = localStorageData?.surveys?.find(survey => survey.current);

      const newSurveyData = localStorageData?.surveys?.map((survey, index) => {
        return surveyDataToSave[index] !== survey ? surveyDataToSave[index] : survey;
      });

      if (actualCurrentSurvey?.id !== newSurveyData?.find(survey => survey.current)?.id) {
        window.scrollTo(0, 0, { behavior: 'smooth' });
      }

      handlers.handleSurveyData({
        ...localStorageData,
        surveys: newSurveyData

      });
    }
  }, [surveyDataToSave]);

  return { setSurveyDataToSave, finishSurvey };

};

export default useSaveSurveyData;